import { Category } from '../types';
import apiClient from './apiClient';

// Тип данных категории
// export interface Category {
//   id: number;
//   name: string;
//   parent_id: number | null;
//   children: Category[];
// }

// Получение списка категорий
export const fetchCategories = async (): Promise<Category[]> => {
  const response = await apiClient.get<Category[]>('/api/categories');
  return response.data;
};
